import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaStar, FaShoppingCart, FaHeart, FaUser, FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';
import { useCart } from '../context/CartContext';

export default function Checkout() {
  const navigate = useNavigate();
  const { cart, clearCart, getCartTotal } = useCart();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    zip: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (cart.length === 0) {
      setError('Ihr Warenkorb ist leer. Bitte wählen Sie Produkte aus.');
      return;
    }
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.address) {
      setError('Bitte füllen Sie alle erforderlichen Felder aus.');
      return;
    }
    clearCart();
    navigate('/success');
  };

  const total = getCartTotal();

  return (
    <div>
      <Helmet>
        <title>Kasse - Novurem Patisserie</title>
        <meta name="description" content="Geben Sie Ihre Lieferdaten ein und schließen Sie Ihre Bestellung bei Novurem ab." />
      </Helmet>

      <section className="page-header">
        <div className="container">
          <h1>Kasse</h1>
          <p>Bitte geben Sie Ihre Lieferdaten ein.</p>
        </div>
      </section>

      <section className="cart-section">
        <div className="container">
          {cart.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <div className="success-icon"><FaShoppingCart /></div>
              <h2 style={{ color: '#7b1e3a', marginBottom: '15px' }}>Keine Produkte in der Bestellung</h2>
              <p>Fügen Sie zuerst Produkte zum Warenkorb hinzu, bevor Sie die Bestellung abschließen.</p>
              <div style={{ marginTop: '20px' }}>
                <button onClick={() => navigate('/')} className="btn btn-primary"><FaHome /> Zur Startseite</button>
              </div>
            </div>
          ) : (
            <div className="checkout-form">
              <h2 style={{ color: '#7b1e3a', marginBottom: '20px' }}>Ihre Bestellung</h2>
              {cart.map((item) => (
                <div key={item.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #fdf3e3' }}>
                  <span>{item.name} (x{item.quantity})</span>
                  <span>{(item.price * item.quantity).toFixed(2)} €</span>
                </div>
              ))}
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px 0', fontWeight: 'bold', color: '#7b1e3a', fontSize: '18px' }}>
                <span>Gesamtsumme:</span>
                <span>{total.toFixed(2)} €</span>
              </div>

              {error && (
                <div style={{ background: '#c94f6f', color: '#fff', padding: '12px', borderRadius: '10px', marginBottom: '15px', fontSize: '14px' }}>
                  {error}
                </div>
              )}

              <h3 style={{ color: '#7b1e3a', margin: '20px 0 15px' }}>Lieferadresse</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="firstName">Vorname *</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    placeholder="Ihr Vorname"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Nachname *</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    placeholder="Ihr Nachname"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">E-Mail-Adresse *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Ihre E-Mail-Adresse"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Telefonnummer</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Ihre Telefonnummer"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="address">Straße und Hausnummer *</label>
                  <input
                    type="text"
                    id="address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                    placeholder="Ihre Straße und Hausnummer"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="zip">Postleitzahl *</label>
                  <input
                    type="text"
                    id="zip"
                    name="zip"
                    value={formData.zip}
                    onChange={handleChange}
                    required
                    placeholder="Ihre Postleitzahl"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="city">Stadt *</label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                    placeholder="Ihre Stadt"
                  />
                </div>
                <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
                  <FaHeart /> Bestellung abschließen
                </button>
              </form>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}